import classNames from 'classnames';
import React, { FC } from 'react';

import { CardContent } from './components/card-content/card-content';
import { CardCTA } from './components/card-cta/card-cta';
import { CardLabel } from './components/card-label/card-label';
import { CardMedia } from './components/card-media/card-media';
import { CardComposition, CardProps } from './models';

const Card: FC<CardProps> & CardComposition = ({
  className,
  children,
  variant = 'standard',
  hasMedia,
}) => (
  <article
    className={classNames(
      'cds-card',
      {
        [`cds-card--variant-${variant}`]: variant,
        [`cds-card--no-media`]: !hasMedia,
      },
      className
    )}
  >
    {children}
  </article>
);
Card.CardMedia = CardMedia;
Card.CardContent = CardContent;
Card.CardLabel = CardLabel;
Card.CardCTA = CardCTA;
export { Card };
